import React, { useState } from "react";
import {
  Dropdown,
  DropdownToggle,
  Offcanvas,
  OffcanvasBody,
  ButtonGroup,
  Label,
  InputGroup,
} from "reactstrap";
import { Container, Row, Button, Col, FormGroup, Input } from "reactstrap";

import ArrowRight from "assets/icon/arrow-right-purple.svg";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import patientsScanImage from "assets/images/patients-scan.svg";
import doubleArrow from "assets/icon/double-arrow-down.svg";
import Checkbox from "components/common/Fields/Checkbox";
import columnSelectorIcon from "../../../../../assets/icon/column-selector.svg";
import editIocn from "../../../../../assets/inventory/edit-icon.svg";
import deleteIcon from "../../../../../assets/inventory/delete-icon.svg";
import CloseIcon from "../../../../../assets/icon/chatClose.svg";
import greenCircle from "../../../../../assets/icon/status-green-circle.svg";
import redCircle from "../../../../../assets/icon/red-status-icon.svg";
import SearchButtons from "components/SearchButtons";
import ReactStrapTable from "components/reactStrapTable";
import { cellRendererToolTip } from "utils/columns";
import upArrow from "../../../../../assets/inventory/up-arrow.svg";
import downArrow from "../../../../../assets/inventory/down-arrow.svg";
import addIcon from "../../../../../assets/icon/add-icon.svg";
import cancelIcon from "../../../../../assets/icon/cancel-icon.svg";
import ReceiveOrderMoreDetails from "../ReceiveOrderMoreDetails/Index";
import leftArrow from "../../../../../assets/icon/left-arrow.svg";
import DrugName from "components/DrugName";

// import MoreDetails from "../MoreDetails/Index";

const ReceiveOrderDetails = () => {
  const [open, setOpen] = useState("onorders");
  const [editDetails, setEditDetails] = useState(false);
  const [showPatientsDetails, setPatientsDetails] = useState(false);
  const [increment, setIncrement] = useState(0);
  const [todosOne, setTodosOne] = useState([]);
  const [locateBtn, setLocateBtn] = useState(true);
  const [rSelected, setRSelected] = useState("off");
  const [tableData, setTableData] = useState(rowData);
  //  const [tableData, setTableData] = useState(rowData);

  const [dataRow, setDataRow] = useState([]);
  const [data, setData] = useState({
    one: "",
  });

  const navigate = useNavigate();

  const locate = useLocation();
  const rowDatas = locate.state;

  const togglebtn = (id) => {
    if (open === id) {
      setOpen();
    } else {
      setOpen(id);
    }
  };
  const togglePatientsDetails = () => {
    setPatientsDetails(!showPatientsDetails);
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setData({ ...data, [name]: value });
  };

  const handleRowClick = () => {
    setEditDetails(true);
  };

  const handleSubmit = (field) => {
    const newEntry = { id: Date.now(), value: data[field] };
    if (data.one !== "") {
      setTodosOne([...todosOne, newEntry]);
    }
    setData({ ...data, [field]: "" });
  };
  const handleDelete = (id, field) => {
    setTodosOne(todosOne.filter((item) => item.id !== id));
  };
  const columnData = [
    {
      id: "1",
      dataField: "all",
      text: (
        <span className="d-flex justify-content-start align-items-center gap-2">
          <Checkbox /> All
        </span>
      ),
      show: true,
      width: 50,
    },
    {
      id: 8,
      dataField: "status",
      text: "Status",
      show: true,
      width: 80,
    },
    {
      id: "2",
      dataField: "exceptions",
      text: "Exceptions",
      show: true,
      width: 150,
      sort: true,
    },

    {
      id: "6",
      dataField: "drugname",
      text: "Drug Name",
      show: true,
      width: 120,
      sort: true,
      cellRenderer: (rowData) => DrugName(rowData),
    },

    {
      id: "7",
      dataField: "npcupc",
      text: "NDC/UPC",
      show: true,
      width: 110,
      sort: true,
    },

    {
      id: "9",
      dataField: "orderqty",
      text: "Order QTY",
      show: true,
      width: 100,
      sort: true,
      cellRenderer: (rowData) => (
        <div onClick={() => setEditDetails(!editDetails)}>
          {rowData.orderqty}
        </div>
      ),
    },
    {
      id: "10",
      dataField: "shippedqty",
      text: "Shipped QTY",
      show: true,
      width: 100,
      sort: true,
    },
    {
      id: "11",
      dataField: "receivedQty",
      text: "Received QTY",
      show: true,
      width: 50,
      sort: true,
      cellRenderer: () => (
        <div className="qty-count" style={{ width: "107px" }}>
          <div>{increment}</div>
          <div className="d-flex flex-column cursor-pointer">
            <img src={upArrow} onClick={() => setIncrement(increment + 1)} />
            <img src={downArrow} onClick={() => setIncrement(increment - 1)} />
          </div>
        </div>
      ),
    },
  ];

  const toggleFilter = () => {
    setRSelected((prev) => (prev === "off" ? "on" : "off"));
  };

  const rowData = [
    {
      id: "33332323",
      all: (
        <div>
          <Checkbox />
        </div>
      ),
      status: <img src={greenCircle} />,
      exceptions: "-",
      drugname: "Lisinopril 10mg Tablet (1000 EA/BTL)",
      npcupc: "1234567890",

      orderqty: "10 BTL",
      shippedqty: "10 BTL",
      receivedQty: (rowData) => {
        rowData.receivedQty;
      },
    },
    {
      id: 421123,
      all: (
        <div>
          <Checkbox />
        </div>
      ),
      status: <img src={greenCircle} />,
      exceptions: "Limited DC availablity",
      drugname: "Metformin 500mg Tablet",
      npcupc: "42415977579",
      orderqty: "5 BTL",
      shippedqty: "3 BTL",
      receivedQty: (rowData) => {
        rowData.receivedQty;
      },
    },
    {
      id: 52222,
      all: (
        <div>
          <Checkbox />
        </div>
      ),
      status: <img src={greenCircle} />,
      exceptions: "-",
      drugname: "Amlodipine 5mg Tablet)",
      npcupc: "38613370164",
      orderqty: "8 BTL",
      shippedqty: "8 BTL",
      receivedQty: (rowData) => {
        rowData.receivedQty;
      },
    },
    {
      id: "63444",
      all: (
        <div>
          <Checkbox />
        </div>
      ),
      status: <img src={greenCircle} />,
      exceptions: "-",
      drugname: "Omeprazole 20mg Capsule",
      npcupc: "48548142434",
      orderqty: "3 BTL",
      shippedqty: "3 BTL",
      receivedQty: (rowData) => {
        rowData.receivedQty;
      },
    },
    {
      id: "092",

      all: (
        <div>
          <Checkbox />
        </div>
      ),
      status: <img src={greenCircle} />,
      exceptions: "Substituted Eqv.NDC",
      drugname: "Gabapentin 300mg Capsule",
      npcupc: "92497230725",
      orderqty: "5 BTL",
      shippedqty: "5 BTL",
      receivedQty: (rowData) => {
        rowData.receivedQty;
      },
    },
    {
      id: "6222222222",
      all: (
        <div>
          <Checkbox />
        </div>
      ),
      status: <img src={greenCircle} />,
      exceptions: "-",
      drugname: "Simvastatin 20mg Tablet ",
      npcupc: "95757803602",
      orderqty: "4 BTL",
      shippedqty: "4 BTL",
      receivedQty: (rowData) => {
        rowData.receivedQty;
      },
    },
    {
      id: "62333",
      all: (
        <div>
          <Checkbox />
        </div>
      ),
      status: <img src={greenCircle} />,
      exceptions: "-",
      drugname: "Sertraline 50mg Tablet ",
      npcupc: "79889412208",
      orderqty: "3 BTL",
      shippedqty: "3 BTL",
      receivedQty: (rowData) => {
        rowData.receivedQty;
      },
    },
    {
      id: "633",
      all: (
        <div>
          <Checkbox />
        </div>
      ),
      status: <img src={greenCircle} />,
      exceptions: "-",
      drugname: "Pantoprazole 40mg Tablet ",
      npcupc: "39638933844",
      orderqty: "2 BTL",
      shippedqty: "2 BTL",
      receivedQty: (rowData) => {
        rowData.receivedQty;
      },
    },
  ];
  return (
    <Container fluid className="details-page-body bg-white p-3 pb-2">
      <Container fluid>
        <Container
          fluid
          className="d-flex justify-content-start align-items-center mb-1 pb-2 gap-2 section-devider-border"
        >
          <img
            src={leftArrow}
            className="cursor-pointer left-arrow-btn"
            onClick={() => navigate(-1)}
          />
          <div className="heading-text">Order ID-1023850</div>
        </Container>
        <div>
          <div className="border mb-2 p-6 bg-white bx-shadow">
            <Row>
              <Col md={12}>
                <h3 className="patient-demo" onClick={togglePatientsDetails}>
                  Vendor Details
                  <span>
                    {showPatientsDetails ? (
                      <>
                        <img
                          src={doubleArrow}
                          style={{
                            transform: "rotate(180deg)",
                            transition:
                              "opacity 0.3s ease, transform 0.3s ease",
                            marginLeft: "8px",
                          }}
                        />
                        <div
                          style={{
                            borderBottom: "1px solid #D3D3D3",
                            marginTop: "8px",
                          }}
                        ></div>
                      </>
                    ) : (
                      <img
                        src={doubleArrow}
                        style={{
                          transition: "opacity 0.3s ease",
                          marginLeft: "8px",
                        }}
                      />
                    )}
                  </span>
                </h3>
                {showPatientsDetails ? (
                  <Row>
                    <div className="d-flex justify-content-between">
                      <div>
                        <div class="pdetails">Wholesaler</div>
                        <div className="patient-details">
                          {rowDatas.wholeSalerName}
                        </div>
                      </div>
                      <div>
                        <div class="pdetails">Order Number</div>
                        <div className="patient-details">MCK-2025012801</div>
                      </div>
                      <div>
                        <div className="pdetails ">Order Date</div>
                        <div className="patient-details">20/01/2025</div>
                      </div>
                      <div>
                        <div className="pdetails">Total Items</div>
                        <div className="patient-details">12</div>
                      </div>
                    </div>
                    <div className="d-flex justify-content-between mt-2">
                      <div>
                        <div className="pdetails ">Ship Date</div>
                        <div className="patient-details">21/01/2025</div>
                      </div>
                      <div>
                        <div className="pdetails ">PO Memo</div>
                        <div className="patient-details">
                          Weekly Stock Order
                        </div>
                      </div>
                      <div>
                        <div className="pdetails ">Order Confirmation</div>
                        <div className="patient-details">CNF-7724691</div>
                      </div>
                      <div>
                        <div className="pdetails ">Total Packages</div>
                        <div className="patient-details">43</div>
                      </div>
                    </div>

                    <div className="d-flex justify-content-between  mt-2">
                      <div>
                        <div className="pdetails ">Total Cost</div>
                        <div className="patient-details">$ 2,752.95</div>
                      </div>
                      <div>
                        <div className="pdetails ">Exceptions</div>
                        <div className="patient-details">3</div>
                      </div>
                      <div>
                        <div className="pdetails"></div>
                        <div className="patient-details"></div>
                      </div>
                      <div>
                        <div className="pdetails "></div>
                        <div className="patient-details"></div>
                      </div>
                    </div>
                  </Row>
                ) : (
                  <div className="d-flex justify-content-between">
                    <div>
                      <span class="pdetails">Wholesaler: </span>
                      <span className="patient-details">
                        {rowDatas.wholeSalerName}
                      </span>
                    </div>

                    <div>
                      <span className="pdetails purple-border-left ">
                        Order Number:{" "}
                      </span>
                      <span className="patient-details">MCK-2025012801</span>
                    </div>

                    <div>
                      <span className="pdetails purple-border-left ">
                        Order Date:{" "}
                      </span>{" "}
                      <span className="patient-details">01/20/2025</span>
                    </div>
                    <div>
                      <span className="pdetails purple-border-left ">
                        Ship Date:{" "}
                      </span>
                      <span className="patient-details">21/01/2025</span>
                    </div>
                    <div>
                      <span className="pdetails purple-border-left">
                        Total Item:{" "}
                      </span>
                      <span className="patient-details">12</span>
                    </div>
                  </div>
                )}
              </Col>
            </Row>
          </div>

          <div className="table-card scroll-table position-relative border-0 pt-0 rounded bg-white">
            <div className="d-flex justify-content-between align-items-center">
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-start",
                  alignItems: "center",
                  gap: "10px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    gap: "6px",
                    alignItems: "baseline",
                  }}
                >
                  <div>
                    {" "}
                    <Label style={{ color: "#702C62" }}>Product Details</Label>
                  </div>
                  <div>
                    <SearchButtons
                      InSize={230}
                      placeHolder={"Search by Product name"}
                      data={rowData}
                      setFilterData={tableData}
                    />
                  </div>
                </div>
                {locateBtn ? (
                  <>
                    <div>
                      <Dropdown isOpen={undefined} toggle={undefined}>
                        <DropdownToggle className="clmn">
                          <img src={columnSelectorIcon} alt="not available" />
                          <span>
                            Columns{" "}
                            {/* {totalCount > 0 && (
                      <div className="totalcount">{totalCount}</div>
                    )} */}
                          </span>
                        </DropdownToggle>
                      </Dropdown>
                    </div>
                    <div className="d-flex justify-content-end align-items-center gap-2">
                      <span className="f-16 font-weight-600">Filter</span>
                      <ButtonGroup className="filter-btn-group">
                        <Button
                          color="info"
                          outline
                          onClick={toggleFilter}
                          active={rSelected === "off"}
                        >
                          OFF
                        </Button>
                        <Button
                          color="info"
                          outline
                          active={rSelected === "on"}
                          onClick={toggleFilter}
                        >
                          ON
                        </Button>
                      </ButtonGroup>
                    </div>
                  </>
                ) : (
                  <></>
                )}
              </div>
              <div>
                <Button color="primary"> Print Shelf Labels</Button>
              </div>
            </div>
            <div
              fixed-height={rowData?.length > 0 ? "fixed-height" : "default"}
            >
              <ReactStrapTable
                id="order-quee-details"
                height={100}
                columns={columnData}
                data={rowData}
                enablerowRouting={true}
                handleRowClick={handleRowClick}
              />
            </div>

            <div
              style={{
                backgroundColor: "#DBCAD8",
                padding: "10px",
                marginTop: "20px",
              }}
            >
              <h2 className="f-16" style={{ fontWeight: "600" }}>
                Manual Entry
              </h2>
              <div style={{ backgroundColor: "#DBCAD8", display: "flex" }}>
                {" "}
                <Input
                  name="one"
                  type="text"
                  value={data.one}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^\d*$/.test(value)) {
                      handleChange(e);
                    }
                  }}
                  placeholder="Enter Product NDC/UPC"
                  autoComplete="off"
                />
                <Button
                  className="ms-2"
                  onClick={() => {
                    handleSubmit("one");
                  }}
                  src={addIcon}
                  alt="not available"
                  color="primary"
                >
                  +
                </Button>
              </div>

              {todosOne.map((name, id) => (
                <div key={name.id} className="dataBox">
                  {name.value}{" "}
                  <img
                    onClick={() => handleDelete(name.id, "one")}
                    src={cancelIcon}
                    alt="not available"
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </Container>
      <Container fluid className="received-detail-footer">
        <Button
          disabled={locateBtn ? false : true}
          className="reset btn btn-primary"
        >
          Backorder
        </Button>
        {locateBtn && (
          <Button
            disabled={locateBtn ? false : true}
            className="reset btn btn-primary"
          >
            Substitute
          </Button>
        )}
        <Button
          className="back-button"
          color={locateBtn ? "primary" : "tranparent"}
          disabled={locateBtn ? false : true}
          onClick={() => setLocateBtn(false)}
        >
          Locate
        </Button>
        <Button
          disabled={locateBtn ? false : true}
          className="back-button"
          color={locateBtn ? "primary" : "tranparent"}
        >
          Complete Package
        </Button>
      </Container>
      <div>
        <Offcanvas
          direction="end"
          isOpen={editDetails}
          toggle={() => setEditDetails(!editDetails)}
        >
          <div className="casvas-header ">
            <div>More Details</div>
            <div
              className="cursor-pointer"
              onClick={() => setEditDetails(!editDetails)}
            >
              <img src={CloseIcon} />
            </div>
          </div>
          <div className="border-canvas"></div>

          <OffcanvasBody>
            <ReceiveOrderMoreDetails />
          </OffcanvasBody>
          <div className="footer-btns">
            <div></div>
            <div className="d-flex">
              <Button
                color="primary"
                className="reset"
                onClick={() => setEditDetails(false)}
              >
                Back
              </Button>
              <Button color="primary">Refresh</Button>
            </div>
          </div>
        </Offcanvas>
      </div>
    </Container>
  );
};
export default ReceiveOrderDetails;
